// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBeeljaBV-P85-Q0by7vAycGHXnxAG3y8I",
  authDomain: "castromello-website.firebaseapp.com",
  projectId: "castromello-website",
  storageBucket: "castromello-website.appspot.com",
  messagingSenderId: "340578312721",
  appId: "1:340578312721:web:0b879b72229d90e1cd87b0",
  measurementId: "G-R6LG6EB4QW",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
